import { Injectable } from '@angular/core';
import { BaseApiService } from '../../../comun/services/api/base-api.service';
import { Auto, Marca, Modelo, TipoVehiculo, Version } from '../../../comun/model/autos.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AutosApiService extends BaseApiService {
  getVersionesPorMatricula(matricula: String): Observable<Auto> {
    return this.invocarSeguros<Auto>('GET', `autos/versiones-matricula/${matricula}`, true);
  }

  getVersiones(categoria: number, nombreMarca: string, nombreModelo: string): Observable<Version[]> {
    return this.invocarSeguros<Version[]>('GET', `autos/versiones/${categoria}/${nombreMarca}/${nombreModelo}`, true);
  }

  getMarcasDestacadas(tipoVehiculo: Number): Observable<Marca[]> {
    return this.invocarSeguros<Marca[]>('GET', `autos/marcas-destacadas/${tipoVehiculo}`, true);
  }

  getMarcas(tipoVehiculo: Number): Observable<Marca[]> {
    return this.invocarSeguros<Marca[]>('GET', `autos/marcas/${tipoVehiculo}`, true);
  }

  getModelosDestacados(tipoVehiculo: Number, idMarca: Number): Observable<Modelo[]> {
    return this.invocarSeguros<Modelo[]>('GET', `autos/modelos-destacados/${tipoVehiculo}/${idMarca}`, true);
  }

  getModelos(tipoVehiculo: Number, nombreMarca: string): Observable<Modelo[]> {
    return this.invocarSeguros<Modelo[]>('GET', `autos/modelos/${tipoVehiculo}/${nombreMarca}`, true);
  }

  getTiposVehiculo(): Observable<TipoVehiculo[]> {
    return this.invocarSeguros<TipoVehiculo[]>('GET', 'autos/tipos-vehiculo', true);
  }
    
}
